import {
  getProfile,
  getOwnProfile,
  createWatchlists,
  getPlayers,
  getPlayerCount,
  getWatchlistPlayers,
  getTournamentAndResults,
  getBucketMatchups,
  getCommonMatches,
  getVsInfo,
  commonCompetitorMatches,
  updateOwnProfile,
  getAccountDetails,
  updateAccount,
  getRegistrationDetails,
  getSocialMatches,
  createFastTrackDetails,
  createAccountDetails,
  createRegistrationDetails,
  getSuggestions,
  createSuggestion,
  getApprovedMatches,
  getPlayerStats,
  createProfile,
  worldTennisNumber,
  getAggregatedResultCount,
  createMatchSides,
  createSocialMatch,
  createWorldTennisNumber,
  getEarliestRatings,
  createWorldTennisNumberHistoryRating,
  getRatings,
  getWatchlists,
  createWatchlist,
} from './data-objects/'

const apiResponse = {
  getRegistrationDetails,
  getProfile,
  getOwnProfile,
  getTournamentAndResults,
  getVsInfo,
  getCommonMatches,
  commonCompetitorMatches,
  getAggregatedResultCount,
  getRatings,
  getEarliestRatings,
  getPlayers,
  getPlayerCount,
  getPlayerStats,
  getWatchlistPlayers,
  getBucketMatchups,
  updateOwnProfile,
  getAccountDetails,
  updateAccount,
  personSubmitPSQ: {},
  getSocialMatches,
  getSuggestions,
  getApprovedMatches,
  worldTennisNumber,
  getWatchlists,
}

export const helpers = {
  createWatchlists,
  createFastTrackDetails,
  createAccountDetails,
  createRegistrationDetails,
  createSuggestion,
  createProfile,
  createMatchSides,
  createSocialMatch,
  createWorldTennisNumber,
  createWorldTennisNumberHistoryRating,
  createWatchlist,
} as const

export default apiResponse
